export const ALLOWED_FILE_EXTENSIONS = new Set([
  // Documents
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'txt',
  'csv',
  'rtf',
  'odt',
  'ods',
  'odp',
  'numbers',
  'msg',
  'eml',
  // Images
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  // Audio
  'm4a',
  'mp3',
  // Video
  'mov',
]);

export const ALLOWED_MIME_TYPES = new Set([
  // Documents
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'text/csv',
  'application/rtf',
  'text/rtf',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.presentation',
  // Images
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  // Audio
  'audio/mp4',
  'audio/x-m4a',
  'audio/mpeg',
  'audio/mp3',
  // Video
  'video/quicktime',
  // Email
  'message/rfc822',
  'application/vnd.ms-outlook',
  // Apple Numbers
  'application/vnd.apple.numbers',
]);

export const BLOCKED_FILE_EXTENSIONS = new Set([
  'exe',
  'bat',
  'sh',
  'js',
  'ts',
  'py',
  'rb',
  'php',
  'cmd',
  'vbs',
  'ps1',
  'jar',
  'dll',
  'msi',
  'deb',
  'rpm',
  'apk',
  'zip',
]);

export const FILE_INPUT_ACCEPT = [
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.txt',
  '.csv',
  '.rtf',
  '.odt',
  '.ods',
  '.odp',
  '.numbers',
  '.msg',
  '.eml',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
  '.m4a',
  '.mp3',
  '.mov',
].join(',');

const getExtension = (fileName: string): string =>
  (fileName.split('.').pop() ?? '').toLowerCase();

export const validateFileUpload = (
  fileName: string,
  mimeType?: string,
): { valid: boolean; reason?: string } => {
  const ext = getExtension(fileName);

  if (!ext) {
    return { valid: false, reason: 'File must have an extension.' };
  }

  if (BLOCKED_FILE_EXTENSIONS.has(ext)) {
    return { valid: false, reason: `Files with .${ext} extension are not allowed.` };
  }

  if (!ALLOWED_FILE_EXTENSIONS.has(ext)) {
    return {
      valid: false,
      reason:
        'File type is not supported. Please upload a document (PDF, Word, Excel, PowerPoint) or image (PNG, JPG, GIF, WebP).',
    };
  }

  if (mimeType && mimeType !== 'application/octet-stream') {
    const normalizedMime = mimeType.toLowerCase().split(';')[0].trim();
    if (!ALLOWED_MIME_TYPES.has(normalizedMime)) {
      return { valid: false, reason: 'File MIME type is not permitted.' };
    }
  }

  return { valid: true };
};
